import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoading: false,
  matrizSucesion: null,
  matrizSucesionError: "",
  matrizSucesionLength: 0,
  formError: "",
}

export default function MatrizSucesionReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_MATRIZ_SUCESION:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_MATRIZ_SUCESION:
      return { ...state, saveLoading: action.payload };
    case actions.GET_MATRIZ_SUCESION:
      return {
        ...state,
        matrizSucesion: action.payload.matrizSucesion,
        matrizSucesionLength: action.payload.matrizSucesionLength,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.MATRIZ_SUCESION_FAIL:
      return { ...state, matrizSucesionError: action.payload };
    default:
      return state;
  }
}